import moment from 'moment-timezone';
import { PropTypes } from 'prop-types';
import { useEffect, useRef } from 'react';
import DatePicker from 'react-datepicker';
import { useAppContext } from '../../providers/AppProvider';

const DateTimePicker = (props) => {
  const {
    input: { value },
    placeholderText,
    showToday,
    required,
    className,
    timeProps,
    disabled,
    minDate,
    maxDate,
  } = props;
  const tz = sessionStorage.getItem('timeZone')
    ? sessionStorage.getItem('timeZone')
    : useAppContext().timeZone;

  const today = showToday ? 'Today' : null;
  const selected = value ? moment.tz(value, tz) : null;
  const classNames = `form-control ${className || ''}`;
  const datePickerRef = useRef(null);

  const onChange = (date) => {
    if (date) {
      const formattedDate = timeProps
        ? moment(date).format('YYYY-MM-DD HH:mm')
        : moment(date).format('YYYY-MM-DD');
      const dateInSiteTimeZone = moment.tz(formattedDate, tz);
      props.input.onChange(dateInSiteTimeZone);
    } else {
      props.input.onChange(date);
    }
  };

  useEffect(() => {
    const inputEl = datePickerRef.current.input;
    inputEl.setAttribute('readonly', true);
  }, []);

  const getSelected = () => (value ? moment.tz(value, tz).format('YYYY-MM-DDTHH:mm') : null);
  return (
    <DatePicker
      ref={datePickerRef}
      className={classNames}
      placeholderText={placeholderText}
      todayButton={today}
      selected={selected && moment(getSelected()).toDate()}
      onChange={(date) => onChange(date)}
      required={required}
      disabled={disabled}
      minDate={minDate}
      maxDate={maxDate}
      fixedHeight
      {...timeProps}
    />
  );
};

DateTimePicker.propTypes = {
  input: PropTypes.shape({ value: PropTypes.any, onChange: PropTypes.func }).isRequired,
  timeProps: PropTypes.shape({}),
  placeholderText: PropTypes.string,
  showToday: PropTypes.bool,
  required: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
};

export default DateTimePicker;
